import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=0245f9b8&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=ts"
export * from "./Requests.vue?vue&type=script&lang=ts"
import style0 from "./Requests.vue?vue&type=style&index=0&id=0245f9b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0245f9b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0245f9b8')) {
      api.createRecord('0245f9b8', component.options)
    } else {
      api.reload('0245f9b8', component.options)
    }
    module.hot.accept("./Requests.vue?vue&type=template&id=0245f9b8&scoped=true", function () {
      api.rerender('0245f9b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/Requests.vue"
export default component.exports